import { render, staticRenderFns } from "./IconShutterstock.vue?vue&type=template&id=a1564584&"
import script from "./IconShutterstock.vue?vue&type=script&lang=js&"
export * from "./IconShutterstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports